<div class="dialog-container" [ngClass]="'dialog-container-hint grid'">
  <div class="web-close-icon">
    <button matTooltipPosition="above" data-dismiss="modal" (click)="closeDialog()" class="web-close-btn">
      <span class="material-icons" style="position: relative">clear</span>
    </button>
  </div>

  <div [class]="'security-key-wrapper flex items-center flex-col h-fit'">
    <!-- @if(!data?.manageSecuritykey ){
    <div class="security-img-container">
      <img src="../../../../../../../assets/images/security-key-green.svg" class="security-key-img" />
    </div>
    }@else { -->
    <div class="bg-[#F3F6FA] rounded-[50%] w-20 h-20 flex items-center justify-center">
      <span class="material-icons mx-0 text-k-blue"> visibility </span>
    </div>
    <!-- } -->

    <div class="security-text-container">
      <h2 [class]="data?.manageSecuritykey ? 'text-k-black font-bold text-2xl security-text-main' : 'security-text-main'">
        {{ data?.manageSecuritykey ? 'Hint' : 'Security Key' }}
      </h2>
      <div class="security-subtext-container">
        @if ((this.data.securityKey && this.data.isHint)) {
        <h2 class="security-sub-text">{{ this.data.securityKey }}</h2>
        } @else {
        <h2 class="security-sub-text">Hint Not Available</h2>
        }
      </div>
    </div>
  </div>
</div>
